import React from 'react';
import classNames from 'classnames';
import {PriorityIcon, Icon, Text} from '@priority-software/priority-style-react';
import {ModernTooltip} from '../Tooltip/ModernTooltip';
import styles from './actionCard.module.scss';

interface PrintTypeCardProps {
    icon: PriorityIcon;
    title: string;
    isSelected: boolean;
    onClick(): void;
    componentClasses?: string;
}

const ActionCard = ({
    icon,
    title,
    isSelected = false,
    onClick,
    componentClasses
}: PrintTypeCardProps) => {
    const classes = classNames(
        styles.typeCard,
        {
            [styles.selected]: isSelected
        },
        componentClasses
    );

    return (
        <button className={classes} data-testid={title} onClick={onClick}>
            <div className={styles.typeIconWrraper}>
                <Icon componentClasses={styles.typeIcon} icon={icon} />
                <Text skin="paragraph-2" textColor="primary-700" componentClasses={styles.cardText}>
                    {title}
                </Text>
            </div>
        </button>
    );
};

export type TypeCardProps = PrintTypeCardProps & {
    tooltip?: string;
    tooltipPortalId?: string;
    tooltipDelay?: number;
};

const TypeCard = ({tooltip, tooltipPortalId, tooltipDelay, ...props}: TypeCardProps) => {
    return (
        <ModernTooltip
            zIndex={10000}
            position="top"
            tooltip={tooltip}
            delay={tooltipDelay || 1000}
            portalId={tooltipPortalId}
        >
            <ActionCard {...props} />
        </ModernTooltip>
    );
};

export default TypeCard;
